const PDPEvents = {
  modal: {
    category: 'PDP',
    action: 'PartnerModalPdp',
    label: 'Partner Modal on PDP',
  },
  modalLink: {
    category: 'PDP',
    action: 'FaqPartnerModal',
    label: 'FAQ Link in Partner Modal on the PDP',
  },
  incentiveModal: {
    category: 'PDP',
    action: 'IncentiveModalPdp',
    label: 'Incentive Modal on PDP',
  },
};

export default PDPEvents;
